<template>
  <content-loader
    :height="560"
    :width="760"
    :speed="2"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <circle cx="251.1" cy="143.1" r="62.1" />
    <circle cx="431.1" cy="143.1" r="62.1" />
    <circle cx="611.1" cy="141.1" r="62.1" />
    <circle cx="248.1" cy="281.1" r="62.1" />
    <circle cx="430.1" cy="281.1" r="62.1" />
    <circle cx="608.1" cy="281.1" r="62.1" />
    <circle cx="248.1" cy="425.1" r="62.1" />
    <circle cx="428.1" cy="422.1" r="62.1" />
    <circle cx="607.1" cy="421.1" r="62.1" />
    <rect x="196.56" y="46.61" rx="0" ry="0" width="107" height="14.96" />
    <rect x="376.56" y="43.61" rx="0" ry="0" width="107" height="14.96" />
    <rect x="555.56" y="42.61" rx="0" ry="0" width="107" height="14.96" />
    <rect x="113.56" y="89.61" rx="0" ry="0" width="16.05" height="97.9" />
    <rect x="113.56" y="249.61" rx="0" ry="0" width="14.98" height="72.16" />
    <rect x="113.56" y="391.61" rx="0" ry="0" width="14.98" height="72.16" />
  </content-loader>
</template>
<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: {
    ContentLoader,
  },
};
</script>



// WEBPACK FOOTER //
// AudienceProfileLoader.vue?493fdefe